import { useRouteError } from "react-router-dom";
import { ResetAll } from "./ResetAll";

export default function ErrorPage() {
  const error = useRouteError();
  console.error("[ErrorPage.rndr]", { error });

  return <ResetAll error={error} />;
}
